import type { ReactNode } from "react";

import type { IconName } from "@luce/ui";
import { Box, Icon, Typography } from "@luce/ui";

interface PackageSectionProps {
  icon: IconName;
  title: string;
  children: ReactNode;
}

export function PackageSection({ icon, title, children }: PackageSectionProps) {
  return (
    <Box className="gap-spacing-md p-spacing-lg flex flex-col">
      <Box className="gap-spacing-md flex flex-row items-center">
        <Icon name={icon} size={24} weight="fill" className="text-luce-brand-primary" />
        <Typography variant="label-lg" color="neutral-foreground-default">
          {title}
        </Typography>
      </Box>
      {children}
    </Box>
  );
}
